import { cloneDeep, get } from 'lodash'

import { Services, getServicePathToAPI, joinURLPath } from '@sigma-frontend-libs/commons'

import { buttonModes, components, globalErrorHandler, icons, request } from '@/utils'

import render from './render'

const pathToAPI = getServicePathToAPI(Services.storage)

export default {
  name: 'FileEdit',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },

    component: {
      type: String,
      default: 'button',
      validator: value => {
        return [ 'button', components['list-item'] ].includes(value)
      }
    }
  },

  data() {
    return {
      currentEditFile: undefined,
      googleFileURL: undefined,

      loading: false,
      showDialog: false
    }
  },

  computed: {
    $_props() {
      const result = {
        icon: icons.description,
        loading: this.loading,
        disabled: this.loading
      }
      switch (this.component) {
        case 'button': {
          result.mode = buttonModes.flat
          result.tooltip = this.getTranslate(`${Services.contracts}.tooltips.edit`)
          break
        }
        case components['list-item']: {
          result.label = this.getTranslate('misc.buttons.edit')
          result.dense = true
          break
        }
      }

      return result
    }
  },

  methods: {
    async edit() {
      try {
        this.loading = true
        const { id, OwnerId } = get(this.value, 'File', {})
        if (id) {
          const data = await request.find(joinURLPath(pathToAPI, 'edit', id), undefined, { OwnerId })
          if (data) {
            this.googleFileURL = data.result
            this.currentEditFile = cloneDeep(this.value.File)
            this.showDialog = true
          }
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
